import { render } from "./ServiceCategoryEndoscopy.vue?vue&type=template&id=1fe0d8dc&ts=true"
import script from "./ServiceCategoryEndoscopy.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryEndoscopy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__